// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navbar base styles */
.navbar {
    background-color: #ffffff; /* Replace with your preferred color */
    padding: 10px 0; /* Vertical padding */
  }
  
  /* Container for navbar content */
  .navbar-container {
    display: flex;
    justify-content: space-between; /* Distribute items at the start and end */
    align-items: center;
    width: 95%; /* Take almost full width but leave some space on the sides */
    margin: 0 auto; /* Center the container horizontally */
  }
  
  /* Left section styles */
  .left-section-nav {
    display: flex;
    align-items: center;
  }
  
  /* Logo container styles */
  .logo-container img {
    height: 50px; /* Adjust height to match your design */
    margin-right: 10px; /* Space between logo and company name */
  }
  
  /* Company name styles */
  .company-name {
    color: black;
    font-size: 16px;
    font-weight: bold;
  }
  
  /* Break lines for company name */
  .company-name span {
    display: block; /* Ensure text wraps */
  }
  
  /* Right section styles */
  .right-section-nav {
    display: flex;
    align-items: center;
  }
  
  /* Navigation links container */
  .nav-links {
    display: flex;
    align-items: center;
    margin-left: 20px; /* Adjust space between sections if needed */
    text-decoration: none;
  }
  
  /* Individual navigation link styles */
  .nav-links a {
    color: black;
    text-decoration: none;
    font-size: 16px;
    margin-right: 20px; /* Adjust spacing between links */
  }
  
  /* Hover effect for links */
  .nav-links a:hover {
    text-decoration: none;
  }
    /* Divider line below the navbar */
    .navbar-divider {
        border: 0;
        height: 1px;
        background-color: #e0e0e0;
        margin: 0 20px;
      }
  /* Login button styles */
  .login-btn {
    background-color: #418ff3; /* Replace with your preferred color */
    color: #ffffff;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  /* Hover effect for login button */
  .login-btn:hover {
    background-color: #3778cc; /* Replace with your preferred color */
  }
  
  /* Adjust spacing for smaller screens */
  @media (max-width: 768px) {
    .navbar-container {
      flex-direction: column; /* Stack vertically on small screens */
      align-items: flex-start; /* Align items to the start */
    }
    .nav-links {
      margin-left: 0; /* Remove margin on small screens */
    }
    .nav-links a, .login-btn {
      margin-right: 10px; /* Reduce margin on small screens */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,yBAAyB,EAAE,sCAAsC;IACjE,eAAe,EAAE,qBAAqB;EACxC;;EAEA,iCAAiC;EACjC;IACE,aAAa;IACb,8BAA8B,EAAE,0CAA0C;IAC1E,mBAAmB;IACnB,UAAU,EAAE,6DAA6D;IACzE,cAAc,EAAE,sCAAsC;EACxD;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,0BAA0B;EAC1B;IACE,YAAY,EAAE,uCAAuC;IACrD,kBAAkB,EAAE,wCAAwC;EAC9D;;EAEA,wBAAwB;EACxB;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA,iCAAiC;EACjC;IACE,cAAc,EAAE,sBAAsB;EACxC;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,+BAA+B;EAC/B;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB,EAAE,4CAA4C;IAC/D,qBAAqB;EACvB;;EAEA,sCAAsC;EACtC;IACE,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,kBAAkB,EAAE,iCAAiC;EACvD;;EAEA,2BAA2B;EAC3B;IACE,qBAAqB;EACvB;IACE,kCAAkC;IAClC;QACI,SAAS;QACT,WAAW;QACX,yBAAyB;QACzB,cAAc;MAChB;EACJ,wBAAwB;EACxB;IACE,yBAAyB,EAAE,sCAAsC;IACjE,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA,kCAAkC;EAClC;IACE,yBAAyB,EAAE,sCAAsC;EACnE;;EAEA,uCAAuC;EACvC;IACE;MACE,sBAAsB,EAAE,sCAAsC;MAC9D,uBAAuB,EAAE,6BAA6B;IACxD;IACA;MACE,cAAc,EAAE,mCAAmC;IACrD;IACA;MACE,kBAAkB,EAAE,mCAAmC;IACzD;EACF","sourcesContent":["/* Navbar base styles */\n.navbar {\n    background-color: #ffffff; /* Replace with your preferred color */\n    padding: 10px 0; /* Vertical padding */\n  }\n  \n  /* Container for navbar content */\n  .navbar-container {\n    display: flex;\n    justify-content: space-between; /* Distribute items at the start and end */\n    align-items: center;\n    width: 95%; /* Take almost full width but leave some space on the sides */\n    margin: 0 auto; /* Center the container horizontally */\n  }\n  \n  /* Left section styles */\n  .left-section-nav {\n    display: flex;\n    align-items: center;\n  }\n  \n  /* Logo container styles */\n  .logo-container img {\n    height: 50px; /* Adjust height to match your design */\n    margin-right: 10px; /* Space between logo and company name */\n  }\n  \n  /* Company name styles */\n  .company-name {\n    color: black;\n    font-size: 16px;\n    font-weight: bold;\n  }\n  \n  /* Break lines for company name */\n  .company-name span {\n    display: block; /* Ensure text wraps */\n  }\n  \n  /* Right section styles */\n  .right-section-nav {\n    display: flex;\n    align-items: center;\n  }\n  \n  /* Navigation links container */\n  .nav-links {\n    display: flex;\n    align-items: center;\n    margin-left: 20px; /* Adjust space between sections if needed */\n    text-decoration: none;\n  }\n  \n  /* Individual navigation link styles */\n  .nav-links a {\n    color: black;\n    text-decoration: none;\n    font-size: 16px;\n    margin-right: 20px; /* Adjust spacing between links */\n  }\n  \n  /* Hover effect for links */\n  .nav-links a:hover {\n    text-decoration: none;\n  }\n    /* Divider line below the navbar */\n    .navbar-divider {\n        border: 0;\n        height: 1px;\n        background-color: #e0e0e0;\n        margin: 0 20px;\n      }\n  /* Login button styles */\n  .login-btn {\n    background-color: #418ff3; /* Replace with your preferred color */\n    color: #ffffff;\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  /* Hover effect for login button */\n  .login-btn:hover {\n    background-color: #3778cc; /* Replace with your preferred color */\n  }\n  \n  /* Adjust spacing for smaller screens */\n  @media (max-width: 768px) {\n    .navbar-container {\n      flex-direction: column; /* Stack vertically on small screens */\n      align-items: flex-start; /* Align items to the start */\n    }\n    .nav-links {\n      margin-left: 0; /* Remove margin on small screens */\n    }\n    .nav-links a, .login-btn {\n      margin-right: 10px; /* Reduce margin on small screens */\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
